import { axiosPrivate, axiosPublic } from '@app/dashboard/tools/axios/axiosInstance';
import { getCapHeadersConfig } from '@app/dashboard/utils/capToken';
import { getRefreshToken } from '@app/dashboard/utils/manageLocalStorage';

export const login = async ({
  userName,
  password,
}: {
  userName: string;
  password: string;
}) => {
  const reqBody = {
    username: userName,
    password: password,
  };

  return axiosPublic.post(`/dashboard/api/v1/login/`, reqBody, await getCapHeadersConfig());
};

export const refreshToken = async () => {
  const refreshToken = getRefreshToken();
  const reqBody = { refresh: refreshToken };

  return axiosPublic.post(`/dashboard/api/v1/refresh-token/`, reqBody);
};

export const loginVerifyOtp = async (otp: string, otpToken: string) => {
  const reqBody = {
    otp: otp,
    token: otpToken,
  };

  return axiosPublic.post(`/dashboard/api/v1/otp-verify/`, reqBody);
};

export const loginResendOtp = async (otpToken: string) => {
  const reqBody = {
    token: otpToken,
  };

  return axiosPublic.post(`/dashboard/api/v1/otp-resend/`, reqBody);
};

export const checkBankAccount = (token: string) => {
  const headers = { "Authorization": `Bearer ${token}` };

  return axiosPrivate.get(`/dashboard/api/v1/balances/`, { headers: headers });
};

export const activeServices = (token: string) => {
  const headers = { "Authorization": `Bearer ${token}` };

  return axiosPrivate.get(`/dashboard/api/v1/services/`, { headers: headers });
};

export const loadPerms = (token: string) => {
  const headers = { "Authorization": `Bearer ${token}` };

  return axiosPrivate.get(`/dashboard/api/v1/permissions/`, { headers: headers });
};